<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">

          <div class="form-card__header">
            <button
              v-if="activeView !== 'payment'"
              type="button"
              class="form-card__btn"
              title="Volver"
              @click="backToPayment">
              <i class="bi bi-arrow-left"></i>
            </button>
            <h6 class="form-card__title">
              <i class="bi" :class="viewIcon"></i>
              {{ viewTitle }}
            </h6>
            <button type="button" class="form-card__btn" @click="cancel">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">

          <template v-if="activeView === 'payment'">

            <!-- SUMMARY -->
            <div class="payment-summary">
              <div class="total-row total-final">
                <span class="label">Total a pagar</span>
                <span class="value">$ {{ round(total, 2) }}</span>
              </div>
              <div class="total-row">
                <span class="label">Efectivo</span>
                <span class="value">$ {{ payarray.cash || 0 }}</span>
              </div>
              <div class="total-row">
                <span class="label">Transferencia</span>
                <span class="value">$ {{ totalTransfer }}</span>
              </div>
              <div v-for="tpcheck in payarray.tpchecks" :key="'chk-' + tpcheck.number" class="total-row">
                <span class="label">Cheque N&deg; {{tpcheck.number}}</span>
                <span class="value">$ {{ round(tpcheck.amount, 2) }}</span>
              </div>
              <div v-for="sfcheck in payarray.sfchecks" :key="'sf-' + sfcheck.number" class="total-row">
                <span class="label">Cheque propio N&deg; {{sfcheck.number}}</span>
                <span class="value">$ {{ round(sfcheck.amount, 2) }}</span>
              </div>
              <div v-for="creditcard in payarray.creditcards" :key="'cc-' + creditcard.coupon" class="total-row">
                <span class="label">{{creditcard.name}} — cup&oacute;n {{creditcard.coupon}}</span>
                <span class="value">$ {{ round(creditcard.amount, 2) }}</span>
              </div>
              <div v-for="(cc, idx) in payarray.accounts" :key="'ac-' + idx" class="total-row">
                <span class="label">Cuenta corriente (venc. {{cc.days}})</span>
                <span class="value">$ {{ cc.amount }}</span>
              </div>
              <div v-if="limited && change > 0" class="total-row">
                <span class="label">Vuelto</span>
                <span class="value text-success">$ {{ round(change, 2) }}</span>
              </div>
              <div v-if="limited && diference != 0" class="total-row">
                <span class="label">Diferencia</span>
                <span class="value text-danger">$ {{ round(diference, 2) }}</span>
              </div>
            </div>

            <div class="totals-divider"></div>

            <!-- Efectivo / Caja -->
            <div class="form-row">
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label">Efectivo <i class="bi bi-cash"></i></label>
                <input v-model.number="payarray.cash" type="number" min="0" step="0.01" class="form-control">
              </div>
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label">Caja procedente <i class="bi bi-safe"></i></label>
                <select v-model="payarray.fund_id" class="form-control" name="fund_id">
                  <option disabled value="0">Seleccione una caja...</option>
                  <option v-for="fund in fundsCash" :key="fund.id" :value="fund.id">{{fund.name.toUpperCase()}}</option>
                </select>
              </div>
            </div>

            <!-- Transferencia / Banco -->
            <div class="form-row">
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label">Transferencia <i class="bi bi-arrow-left-right"></i></label>
                <input
                  v-model.number="transfer"
                  type="number"
                  min="0"
                  step="0.01"
                  class="form-control"
                  @input="updateBanks">
              </div>
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label">Banco procedente <i class="bi bi-bank"></i></label>
                <div class="bank-field">
                  <select v-model="fundTransfer" class="form-control" name="fund_id" @change="updateBanks">
                    <option disabled value="0">Seleccione una caja...</option>
                    <option v-for="fundBank in fundsBank" :key="fundBank.id" :value="fundBank.id">{{fundBank.name}}</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Cuenta corriente -->
            <div v-if="showCc" class="payment-methods__child mt-3">
              <client-account v-on:clientAccountSaved="clientAccountSaved" v-on:clientAccountCancel="showCc=false"/>
            </div>

            <!-- Nota para el proveedor -->
            <div class="form-row">
              <div class="form-group col-md-12 my-4">
                <label class="form-card__label">Nota para el proveedor <i class="bi bi-chat-left-text"></i></label>
                <textarea v-model="payarray.orderNote" class="form-control" rows="2"></textarea>
              </div>
            </div>

          </template>

          <!-- SUB-VISTA: Cheques de terceros -->
          <div v-else-if="activeView === 'tpchecks'" class="payment-methods__child">
            <tpchecktable
              :checks="payarray.tpchecks"
              endpoint='/api/funds/tp_checks/getTpChecksOnWallet'
              v-on:selection-changed="draftTpChecks = $event"/>
          </div>

          <!-- SUB-VISTA: Cheques propios -->
          <div v-else-if="activeView === 'sfchecks'" class="payment-methods__child">
            <div class="sfcheck-tabs">
              <button
                type="button"
                class="sfcheck-tabs__btn"
                :class="{ 'is-active': !seeSfList }"
                @click="seeSfList = false">
                Emitir nuevo
              </button>
              <button
                type="button"
                class="sfcheck-tabs__btn"
                :class="{ 'is-active': seeSfList }"
                @click="seeSfList = true">
                En cartera
              </button>
            </div>
            <div v-show="!seeSfList" class="mt-3">
              <sfcheck
                v-on:sfcheckcancel="backToPayment"
                v-on:sfchecksaved="sfCheckSave"
                :funds='funds'
                :emisionData='emisionData'/>
            </div>
            <div v-show="seeSfList" class="mt-3">
              <sfchecktable
                :checks="payarray.sfchecks"
                endpoint='/api/funds/checks/getChecksOnWallet'
                v-on:selection-changed="draftSfChecks = $event"/>
            </div>
          </div>

          </div>

          <div class="form-card__footer payment-methods-footer">

            <!-- FOOTER: vista de pago -->
            <template v-if="activeView === 'payment'">
              <div class="payment-methods-footer__secondary">
                <button v-if="paymentMethods.cuenta_corriente==1" type="button" class="btn btn-light" @click="showCc=!showCc">
                  <i class="bi bi-card-heading"></i> Cuenta corriente
                </button>
                <button v-if="paymentMethods.cheques==1" type="button" class="btn btn-light" @click="openView('tpchecks')">
                  <i class="bi bi-bank"></i> Cheques de terceros
                </button>
                <button v-if="paymentMethods.cheques==1" type="button" class="btn btn-light" @click="openView('sfchecks')">
                  <i class="bi bi-pencil-square"></i> Cheques propios
                </button>
              </div>
              <div class="payment-methods-footer__primary">
                <button v-if="limited" type="button" class="form-card__btn" @click="modified">Modificar</button>
                <button type="button" class="form-card__btn" @click="cancel">Cancelar</button>
                <button
                  type="button"
                  class="form-card__btn form-card__btn--primary"
                  :disabled="!(((round(diference, 2) == 0) || (limited == 0)) && cajasTransferValidas && cajaCashValida)"
                  @click="finishReceipt">
                  <i class="bi bi-check-lg"></i>
                  Finalizar pago
                </button>
              </div>
            </template>

            <!-- FOOTER: sub-vista de selección de cheques -->
            <template v-else>
              <button type="button" class="btn btn-light" @click="backToPayment">
                <i class="bi bi-arrow-left"></i> Volver
              </button>
              <button
                v-if="showApplyButton"
                type="button"
                class="form-card__btn form-card__btn--primary"
                @click="applySelection">
                <i class="bi bi-check-lg"></i>
                Aplicar selecci&oacute;n
              </button>
            </template>

          </div>

        </div>
      </div>
    </div>
  </transition>

</template>

<script>
import clientAccount from './Client-account.vue';
import tpchecktable from './Tpcheck-table.vue';
import sfcheck from './Sf-check.vue';
import sfchecktable from './Sfcheck-table.vue';
import roundMixin from "./../../mixins/roundMixin.js";


export default {
  mixins: [roundMixin ],
  props: ['total', 'paymentMethods', 'header', 'limited', 'fundDefault','emisionData'],
  data: function() {
    return {
      showCreditCard: false,
      // Vista activa del modal: 'payment' (default) o las sub-vistas de selección
      // de cheques a pantalla completa ('tpchecks' | 'sfchecks').
      activeView: 'payment',
      // Selección en curso de cada sub-vista; se commitea recién al tocar "Aplicar".
      draftTpChecks: [],
      draftSfChecks: [],
      showCc: false,
      totalpayed: 0,
      diference: 0,
      change: 0,
      funds: [],
      fundsBank: [],
      payarray: {
        cash: 0,
        fund_id: 0,
        banks: [],
        fundBanks_id: [],
        accounts: [],
        creditcards: [],
        tpchecks: [],
        orderNote:'',
        sfchecks:[],
        transfer: 0,
        bankId: 0,
      },
      limitcc: null,
      seeSfList:false,
      inputSelects: [],
      transfer: 0,
      fundTransfer: 0,
      totalTransfer: 0,
    }
  },
  mounted: function () {
    this.payarray.fund_id = this.fundDefault;
    this.getFunds();
    // Inicializa banks/fundBanks_id con un slot vacío para que el flujo no falle
    // cuando se paga sin transferencia.
    this.updateBanks();
    this.calc();
  },
  watch: {
    payarray: {
      handler: function () {
        this.calc();
      }, deep: true
    }
  },
  computed: {
    // Título del header según la vista activa.
    viewTitle: function () {
      if (this.activeView === 'tpchecks') return 'Cheques de terceros';
      if (this.activeView === 'sfchecks') return 'Cheques propios';
      return 'Métodos de pago de la orden de compra';
    },
    // Ícono del header según la vista activa.
    viewIcon: function () {
      if (this.activeView === 'tpchecks') return 'bi-bank';
      if (this.activeView === 'sfchecks') return 'bi-pencil-square';
      return 'bi-wallet2';
    },
    // "Aplicar selección" solo aplica a vistas de selección desde cartera.
    // En "emitir nuevo cheque propio" el formulario tiene su propio guardado.
    showApplyButton: function () {
      return this.activeView === 'tpchecks' || (this.activeView === 'sfchecks' && this.seeSfList);
    },
    // Caja destino para efectivo: solo cajas de tipo Efectivo (no bancos ni tarjetas).
    fundsCash: function () {
      return this.funds.filter(fund => fund.type === "Efectivo");
    },
    // Si hay efectivo cargado, hay que elegir una caja de efectivo destino.
    cajaCashValida: function () {
      return this.payarray.cash <= 0 || this.payarray.fund_id != 0;
    },
    // Toda línea de transferencia con monto > 0 debe tener una caja banco elegida
    // (no la opción "Seleccione una caja..."). Bloquea el cierre si falta.
    cajasTransferValidas: function () {
      if (this.transfer > 0 && !this.fundTransfer) return false;
      for (var i = 0; i < this.inputSelects.length; i++) {
        if (this.inputSelects[i].input > 0 && !this.inputSelects[i].select) return false;
      }
      return true;
    },
  },
  methods: {
    calc: function () {
      this.totalpayed = 0;

      var interestCreditCards = this.payarray.creditcards.map(el => el.interest).reduce((acc, currentValue) => acc + currentValue, 0);
      var totalCreditCards = this.payarray.creditcards.map(el => el.amount).reduce((acc, currentValue) => acc + currentValue, 0);
      var totalTpChecks = this.payarray.tpchecks.map(el => el.amount).reduce((acc, currentValue) => acc + currentValue, 0);
      var totalSfChecks = this.payarray.sfchecks.map(el => el.amount).reduce((acc, currentValue) => acc + currentValue, 0);
      var totalAccounts = this.payarray.accounts.map(el => el.amount).reduce((acc, currentValue) => acc + currentValue, 0);

      var withoutcash = this.round(totalCreditCards,2) +
        this.round(interestCreditCards,2) +
        this.round(totalTpChecks,2) +
        this.round(totalAccounts,2) +
        this.round(totalSfChecks,2) ;

      var cosa = this.total - withoutcash;
      var totalcash = this.payarray.cash;
      var totalbanks = this.totalTransfer;

      this.change = totalcash - totalbanks - cosa;

      this.totalpayed = this.round(totalcash,2) + this.round(withoutcash,2) + this.round(totalbanks,2);
      this.diference = this.round(this.total,2) - this.round(this.totalpayed,2);
    },
    updateBanks() {
      const banks = [{ amount: this.transfer }];
      const fundTransfer = [{ fund: this.fundTransfer }];
      const inputSelectsBanks = this.inputSelects.map(select => ({
        amount: select.input,
      }));
      const selectSelectsBanks = this.inputSelects.map(select => ({
        fund: select.select,
      }));
      this.payarray.fundBanks_id = fundTransfer.concat(selectSelectsBanks);
      this.payarray.banks = banks.concat(inputSelectsBanks);
      // El backend de pagos (addAllocationPayment) espera la transferencia como
      // escalar: transfer + bankId. En órdenes de pago hay una sola transferencia.
      this.payarray.transfer = Number(this.transfer) || 0;
      this.payarray.bankId = this.fundTransfer;
      this.calcTotalTransfer();
    },
    addInputSelect() {
      this.inputSelects.push({ input: 0, select: '' });
    },
    removeInputSelect(index) {
      this.inputSelects.splice(index, 1);
      this.updateBanks();
    },
    calcTotalTransfer() {
      this.totalTransfer = this.payarray.banks.reduce((sum, bank) => sum + (Number(bank.amount) || 0), 0);
    },
    // Abre una sub-vista de selección de cheques a pantalla completa.
    openView: function (view) {
      if (view === 'tpchecks') this.draftTpChecks = this.payarray.tpchecks.slice();
      if (view === 'sfchecks') {
        this.seeSfList = false;
        this.draftSfChecks = this.payarray.sfchecks.filter(el => el.id != null);
      }
      this.activeView = view;
    },
    // Vuelve a la vista de pago descartando cualquier selección no aplicada.
    backToPayment: function () {
      this.activeView = 'payment';
    },
    // Commitea la selección en curso de la sub-vista activa y vuelve a pago.
    applySelection: function () {
      if (this.activeView === 'tpchecks') {
        this.tpCheckSave(this.draftTpChecks);
      } else if (this.activeView === 'sfchecks' && this.seeSfList) {
        this.sfCheckListSave(this.draftSfChecks);
      }
    },
    tpCheckSave: function(obj) {
      this.payarray.tpchecks= obj;
      this.backToPayment();
    },
    sfCheckSave: function(obj) {
      this.payarray.sfchecks.push(obj);
      this.backToPayment();
    },
    sfCheckListSave: function(list) {
        var toadd = this.payarray.sfchecks.filter(function (el) {return el.id == null;});
        this.payarray.sfchecks= list.concat(toadd);
        this.backToPayment();
    },
    fromdateUpdated: function (date) {
      this.header.service_fromdate = date;
    },
    clientAccountSaved: function (obj) {
      this.payarray.accounts.push(obj);
      this.showCc=false;
    },
    modified: function () {
      this.$emit('paymentmethodschanged',{});
      this.$emit('close');
    },
    cancel: function () {
        this.$emit('paymentmethodschanged',{});
        this.$emit('close');
    //   if (!this.limited) {
    //     window.location.href = '/compras/cc-proveedores/detalle/'+this.header.provider_id;
    //   } else {
    //     window.location.href = '/compras/index/detalle/create/detail';
    //   }
    },
    finishReceipt: function () {
      this.$emit('paymentmethodsclose',this.payarray);
      this.$emit('close')
    },
    getFunds() {
      var vm = this;
      this.$http.get('/api/funds/listSimple')
          .then(response => {
            if(response.data) {
              vm.funds = response.data.data.filter(fund => fund.type != "Tarjeta de Credito");
              vm.fundsBank = response.data.data.filter(fund => fund.type === "Banco");
              // Pre-seleccionar la caja por defecto solo si es de efectivo; si no, dejar el placeholder.
              if (!vm.funds.some(f => f.id == vm.fundDefault && f.type === "Efectivo")) {
                vm.payarray.fund_id = 0;
              }
            }
          })
          .catch(error => {
            alert(error);
          })
    },
  },
  components: {
    clientAccount,
    tpchecktable,
    sfcheck,
    sfchecktable
  }
}
</script>

<style scoped>
/* ---- Modal shell (mismo lenguaje visual que el POS) ---- */
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 100%;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
  background: var(--surface);
  color: var(--text);
}

.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
}

/* ---- Resumen de pago ---- */
.payment-summary {
  max-width: 320px;
}

.payment-summary .total-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 2px 0;
  font-size: 14px;
}

.payment-summary .total-row .label {
  color: var(--text-muted);
}

.payment-summary .total-row .value {
  font-weight: 600;
  color: var(--text);
  text-align: right;
}

.payment-summary .total-final {
  padding: 4px 0;
}

.payment-summary .total-final .label {
  font-size: 24px;
  font-weight: 700;
  color: var(--text);
}

.payment-summary .total-final .value {
  font-size: 26px;
  font-weight: 700;
  color: #4477bd;
}

.totals-divider {
  height: 1px;
  background: var(--border-soft);
  margin: 12px 0;
}

/* ---- Transferencias (input + select banco) ---- */
.bank-field {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.bank-field__add,
.bank-field__remove {
  flex-shrink: 0;
  width: 42px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ---- Métodos hijos (cheques / cuenta) ---- */
.payment-methods__child {
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  padding: 16px;
  background: var(--surface-subtle);
}

/* ---- Segmented control de cheques propios (emitir nuevo / en cartera) ---- */
.sfcheck-tabs {
  display: inline-flex;
  padding: 3px;
  gap: 3px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--surface-muted);
}

.sfcheck-tabs__btn {
  border: 0;
  background: transparent;
  color: var(--text-muted);
  font-size: 13px;
  font-weight: 600;
  padding: 6px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;
}

.sfcheck-tabs__btn.is-active {
  background: var(--surface);
  color: var(--text);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);
}

/* ---- Footer ---- */
.payment-methods-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.payment-methods-footer__secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.payment-methods-footer__secondary .btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.payment-methods-footer__primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* ---- Transición ---- */
.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
